var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.317 19.717a11.162 11.162 0 01-7.718 3.083C5.414 22.8.4 17.785.4 11.6.4 5.414 5.414.4 11.6.4c6.186 0 11.2 5.014 11.2 11.2 0 2.991-1.172 5.708-3.082 7.717a5.07 5.07 0 013.167 1.468l2.334 2.333c.244.245.381.576.381.922v.075l-.001.152a1.4 1.4 0 01-1.332 1.331c-.033.002-.073.002-.152.002h-.075c-.345 0-.677-.137-.921-.382l-2.334-2.333a5.07 5.07 0 01-1.467-3.168zM20 11.6a8.4 8.4 0 11-16.8 0 8.4 8.4 0 0116.8 0z",
    fill: "currentColor"
  })));
};
export default SvgSearch;